/**
 * Cafuster – protección del botón "Añadir al carrito" de los packs.
 *
 * Los packs se desglosan en platos solo si el JS de Loop (loop_widget.js) ha reemplazado el
 * botón del tema por el suyo. Si el cliente pulsa antes (o Loop no llega a cargar), el formulario
 * del tema añade el producto padre (PACK-xxx) como línea única, sin platos ni descuento.
 *
 * Mientras Loop no esté listo: el clic se bloquea y se pone en cola; al estar listo se repite
 * el clic sobre el botón ya gestionado por Loop. Si no llega a cargar, se muestra un aviso y
 * NO se añade nada al carrito. Fichero propio: Loop no lo toca.
 */
(function () {
  var TIMEOUT_MS = 12000;
  var POLL_MS = 100;
  var MESSAGE_ERROR = 'No hemos podido cargar el pack. Recarga la página e inténtalo de nuevo.';

  var guarded = Array.prototype.slice.call(document.querySelectorAll('[data-loop-guard]'));
  if (!guarded.length) return;

  var ready = false;
  var queued = false;
  var failed = false;

  guarded.forEach(function (button) {
    // Loop reemplaza el botón con cloneNode: las propiedades JS no se copian, los atributos sí.
    button.__cfLoopOriginal = true;
    button.classList.add('cf-loop-pending');
    button.setAttribute('aria-busy', 'true');
  });

  function mainButton() {
    return document.getElementById('AddToCart');
  }

  function markReady() {
    if (ready) return;
    ready = true;
    clearInterval(timer);
    clearTimeout(timeout);
    document.querySelectorAll('[data-loop-guard]').forEach(function (button) {
      // 'loading' lo puso este script y el clon de Loop lo hereda: el submit del tema no lo quitará.
      button.classList.remove('cf-loop-pending', 'loading');
      button.removeAttribute('aria-busy');
    });
    if (queued) {
      queued = false;
      var button = mainButton();
      if (button) button.click();
    }
  }

  function checkReady() {
    var button = mainButton();
    if (button && !button.__cfLoopOriginal) markReady();
  }

  function showError(message) {
    document.querySelectorAll('.product-add-to-cart-container .form-notification.error').forEach(function (box) {
      box.textContent = message;
      box.style.display = message ? '' : 'none';
    });
  }

  var timer = setInterval(checkReady, POLL_MS);
  var timeout = setTimeout(function () {
    if (ready) return;
    failed = true;
    clearInterval(timer);
    document.querySelectorAll('[data-loop-guard]').forEach(function (button) {
      button.classList.remove('cf-loop-pending', 'loading');
      button.removeAttribute('aria-busy');
    });
    if (queued) {
      queued = false;
      showError(MESSAGE_ERROR);
    }
  }, TIMEOUT_MS);

  document.addEventListener('loopWidgetLoaded', function () { setTimeout(checkReady, 0); });

  function block(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (failed) {
      showError(MESSAGE_ERROR);
      return;
    }
    if (!queued) {
      queued = true;
      document.querySelectorAll('[data-loop-guard]').forEach(function (button) {
        button.classList.add('loading');
      });
    }
  }

  // Clic en cualquiera de los botones (principal y sticky): captura, antes que el tema y Loop.
  // Loop solo reemplaza el botón principal: el sticky (id AddToCartSticky) enviaría el formulario
  // del tema y añadiría el pack padre aunque Loop esté listo, así que su clic se delega en el principal.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-loop-guard]');
    if (!button) return;
    if (!ready) return block(event);
    if (button.id === 'AddToCartSticky') {
      var main = mainButton();
      if (main && main !== button) {
        event.preventDefault();
        event.stopImmediatePropagation();
        main.click();
      }
    }
  }, true);

  // Envío con Enter desde el campo de cantidad, etc.
  document.addEventListener('submit', function (event) {
    if (ready) return;
    var form = event.target;
    if (form && form.querySelector && (form.querySelector('[data-loop-guard]') || form.id && document.querySelector('[data-loop-guard][form="' + form.id + '"]'))) {
      block(event);
    }
  }, true);
})();
